var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',{attrs:{"header":"my-frame"}},[_c('div',{staticClass:"frame-con"},[_c('my-frame',{attrs:{"src":"http://www.baidu.com"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }